import PropTypes from 'prop-types';
import { useRouter } from 'next/router';

import { track } from 'utils/analytics';
import Button from 'legacy/components/button';
import useDownloadFile from 'hooks/useDownloadFile';

const DownloadButton = ({
  label,
  fileUrl,
  fileName,
  fileType,
  eventName,
  eventData,
  ...props
}) => {
  const router = useRouter();
  const { status, downloadFile } = useDownloadFile(fileUrl, fileName, fileType);

  const handleDownloadClick = async () => {
    track(eventName, {
      ...eventData,
    });

    await downloadFile();

    router.push(`${router.asPath}thanks/`);
  };

  const handleDownloadDown = (e) => {
    if (e.button > 0) {
      let mouseButton;

      switch (e.button) {
        case 1:
          mouseButton = 'middle_mouse';
          break;
        case 2:
          mouseButton = 'right_mouse';
          break;
        default:
          mouseButton = 'mouse';
      }

      track(eventName, {
        mouse_button: mouseButton,
        ...eventData,
      });
    }
  };

  return (
    <Button
      onClick={handleDownloadClick}
      onMouseDown={handleDownloadDown}
      disabled={status === 'loading'}
      {...props}
    >
      {label}
    </Button>
  );
};

DownloadButton.propTypes = {
  label: PropTypes.string,
  fileUrl: PropTypes.string.isRequired,
  fileName: PropTypes.string,
  fileType: PropTypes.string,
  eventName: PropTypes.string.isRequired,
  eventData: PropTypes.object,
};

DownloadButton.defaultProps = {
  label: 'Get Started',
  fileName: '',
  fileType: 'text/plain',
  eventData: {},
};

export default DownloadButton;
